import {
	FETCH_BOOKINGS_SUCCESS,
	GET_BOOKINGS_SUCCESS,
	GET_RESERVATIONS_STATUS_SUCCESS,
	GET_RESERVATIONS_FEEDBACK_SUCCESS,
	SAVE_BOOKING_SUCCESS,
	SAVE_RESERVATION_SUCCESS,
	UPLOAD_BOOKING_IMAGE_SUCCESS,
	DELETE_BOOKING_IMAGE_SUCCESS,
	DELETE_BOOKING_TRANSACTION_SUCCESS,
	RESCHEDULE_SUCCESS,
	GET_BOOKING_EVENTS_SUCCESS,
	SAVE_PREBOOK_IMAGE_SUCCESS,
	DELETE_PREBOOK_IMAGE_SUCCESS,
	FETCH_FEEDBACK_QUESTIONS_SUCCESS,
	SAVE_FEEDBACK_SUCCESS,
	LOGOUT_SUCCESS,
	GET_BOOKING_SUMMARY_SUCCESS,
	GET_WORKSHOP_IMAGES_SUCCESS,
	SAVE_BOOKING_DET_HEADER_STATUS,
	UPDATE_BOOKING_SUMMARY,
	CLEAR_PARTICULAR_BOOKING,
	GET_FEEDBACK_SUCCESS,
	UPDATE_PARTICULAR_BOOKING_DETAILS,
	CLEAR_BOOKING_IMAGES,
	CLEAR_SAVED_FEEDBACK_STATUS,
	// SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS,
} from "../Types";

const initialState = {
	particularBookingDetails: [],
	bookingList: [],
	reservationStatus: [],
	confirmationImages: [],
	activeBooking: {},
	feedbackQuestions: [],
	bookingSummaryDetails: [],
	workshopImages: [],
	bookingHeaderStatus: false,
	savedFeedback: null,
};
export function bookingReducer(state = initialState, action) {
	switch (action.type) {
		case SAVE_BOOKING_SUCCESS:
			return { ...state, confirmationImages: [] };
		case SAVE_RESERVATION_SUCCESS: {
			const { body = {} } = action;
			return { ...state, reservationDetails: body };
		}
		case FETCH_BOOKINGS_SUCCESS: {
			const { body = {} } = action;
			const { data = [] } = body;
			return {
				...state,
				particularBookingDetails: data,
				bookingList: state.bookingList
					.map((ele) => ele.bookingId)
					.includes(data[0].bookingId)
					? state.bookingList
					: [...state.bookingList, data[0]],
			};
		}
		case GET_BOOKINGS_SUCCESS: {
			const { data = [] } = action.body;
			return {
				...state,
				bookingList: data,
			};
		}
		case GET_RESERVATIONS_STATUS_SUCCESS: {
			const { reservationList = [] } = action.body;
			return {
				...state,
				reservationStatus: reservationList,
			};
		}
		case GET_RESERVATIONS_FEEDBACK_SUCCESS: {
			const { feedbackLink = "" } = action.body;
			return {
				...state,
				feedbackLink: feedbackLink,
			};
		}
		case UPLOAD_BOOKING_IMAGE_SUCCESS: {
			const { id = "" } = action.additionalData;
			// console.log("UPLOAD_BOOKING_IMAGE_SUCCESS .... ");
			// console.log("UPLOAD_BOOKING_IMAGE_SUCCESS ===== ", action);
			return {
				...state,
				particularBookingDetails: state.particularBookingDetails.map((ele) => {
					if (ele.bookingId === id) {
						return {
							...ele,
							userImages: !!ele.userImages
								? [...ele.userImages, action.body.data[0].message]
								: [action.body.data[0].message],
						};
					}
					return ele;
				}),
			};
		}
		case DELETE_BOOKING_IMAGE_SUCCESS: {
			const { url = "" } = action.additionalData;
			return {
				...state,
				particularBookingDetails: state.particularBookingDetails.map((ele) => {
					return {
						...ele,
						userImages: !!ele.userImages
							? ele.userImages.filter((img) => {
									return img.split("/").pop() !== url.split("/").pop();
							  })
							: [],
					};
				}),
			};
		}
		case DELETE_BOOKING_TRANSACTION_SUCCESS: {
			const { id = "" } = action.body.data.pop();
			return {
				...state,
				bookingList: state.bookingList.filter((ele) => ele.bookingId !== id),
			};
		}
		case RESCHEDULE_SUCCESS: {
			const { data = [] } = action.body;
			return {
				...state,
				bookingList: state.bookingList.map((ele) => {
					if (ele.bookingId === data[0].bookingId) {
						return data[0];
					}
					return ele;
				}),
			};
		}
		case GET_BOOKING_EVENTS_SUCCESS: {
			return { ...state };
		}
		case SAVE_PREBOOK_IMAGE_SUCCESS: {
			const { body = {} } = action;
			const { data = [], location } = body;
			return {
				...state,
				confirmationImages: [...state.confirmationImages, location],
			};
		}
		// case SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS: {
		//   return { ...state };
		// }
		case DELETE_PREBOOK_IMAGE_SUCCESS: {
			const { body = {} } = action;
			const { data = [] } = body;
			return {
				...state,
				confirmationImages: state.confirmationImages.filter((url) => url !== data[0].id),
			};
		}
		case FETCH_FEEDBACK_QUESTIONS_SUCCESS: {
			const { body = {} } = action;
			const { data = [] } = body;
			return {
				...state,
				feedbackQuestions: data,
			};
		}
		case GET_BOOKING_SUMMARY_SUCCESS: {
			return {
				...state,
				bookingSummaryDetails: action.body.data,
			};
		}
		case SAVE_BOOKING_DET_HEADER_STATUS: {
			return { ...state, bookingHeaderStatus: action.status };
		}
		case UPDATE_BOOKING_SUMMARY: {
			return {
				...state,
				bookingSummaryDetails: action.data,
			};
		}
		case SAVE_BOOKING_DET_HEADER_STATUS: {
			return { ...state, bookingHeaderStatus: action.status };
		}
		case CLEAR_PARTICULAR_BOOKING: {
			return {
				...state,
				particularBookingDetails: [],
			};
		}
		case GET_FEEDBACK_SUCCESS: {
			const { data = [] } = action.body;
			return { ...state, savedFeedback: data[0] };
		}
		case CLEAR_SAVED_FEEDBACK_STATUS: {
			return { ...state, savedFeedback: null };
		}
		case UPDATE_PARTICULAR_BOOKING_DETAILS: {
			return { ...state, particularBookingDetails: action.bookingObj };
		}
		case CLEAR_BOOKING_IMAGES: {
			return {
				...state,
				confirmationImages: [],
			};
		}
		case LOGOUT_SUCCESS: {
			return {
				...initialState,
			};
		}
		default:
			return state;
	}
}
